import { Typography } from '@mui/material';
import * as React from 'react';
import { ChannelItemEPlan } from '../../../../sic-lib/types/ChannelItem';

interface Props {
    channelItem: ChannelItemEPlan;
}

export default React.memo(function ConversationListItemEPlan({ channelItem }: Props) {
    return (
        <Typography variant="body1" display="block" whiteSpace="pre-wrap" p={2}>
            {channelItem.actionSubject}
        </Typography>
    );
});
